import apiClient from './api';
import type { QuickChip } from '../types/chat';

const CHIPS_PATH = '/chips';

export async function getChips(agentId?: string): Promise<QuickChip[]> {
  const params = agentId ? { agentId } : {};
  const response = await apiClient.get<QuickChip[]>(CHIPS_PATH, { params });
  return response.data;
}

export async function createChip(chip: {
  label: string;
  prompt: string;
  agentId?: string | null;
  color?: string;
  order?: number;
}): Promise<QuickChip> {
  const response = await apiClient.post<QuickChip>(CHIPS_PATH, chip);
  return response.data;
}

export async function updateChip(
  id: string,
  updates: Partial<Pick<QuickChip, 'label' | 'prompt' | 'agentId' | 'color' | 'order'>>
): Promise<QuickChip> {
  const response = await apiClient.put<QuickChip>(`${CHIPS_PATH}/${id}`, updates);
  return response.data;
}

export async function deleteChip(id: string): Promise<void> {
  await apiClient.delete(`${CHIPS_PATH}/${id}`);
}
